import createAction from 'Store/utils/createAction';
const START_LOADING = 'START_LOADING';
const END_LOADING = 'END_LOADING';

function endLoading() {
  return createAction(END_LOADING, {});
}

function startLoading(globalLoaderLabel?: string | null | undefined, isNavigation?: boolean) {
  return createAction(START_LOADING, {
    globalLoaderLabel,
    isNavigation,
  });
}

export { START_LOADING, END_LOADING, startLoading, endLoading };
